import { Outlet, Link, useLocation } from 'react-router-dom';
import SearchBar from './SearchBar';

export default function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">S</span>
              </div>
              <span className="text-xl font-bold text-gray-900">SEPOM</span>
            </Link>

            {/* Search Bar - Hidden on mobile */}
            <div className="hidden md:block flex-1 max-w-xl mx-8">
              <SearchBar />
            </div>

            {/* Navigation */}
            <nav className="flex items-center space-x-4">
              <Link
                to="/buscar"
                className={`text-sm font-medium transition-colors ${
                  location.pathname === '/buscar'
                    ? 'text-primary-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Buscar
              </Link>
              <Link
                to="/buscar?tipo=partidos"
                className={`text-sm font-medium transition-colors ${
                  location.pathname.startsWith('/partido')
                    ? 'text-primary-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Partidos
              </Link>
            </nav>
          </div>

          {/* Mobile Search */}
          <div className="md:hidden pb-3">
            <SearchBar />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-white font-bold text-lg mb-4">SEPOM</h3>
              <p className="text-sm text-gray-400">
                Sistema de Estadística Política Mexicana. Transparencia y monitoreo cívico.
              </p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Datos</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/buscar?tipo=senadores" className="hover:text-white">Senadores</Link></li>
                <li><Link to="/buscar?tipo=diputados" className="hover:text-white">Diputados</Link></li>
                <li><Link to="/buscar?tipo=gobernadores" className="hover:text-white">Gobernadores</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Recursos</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="hover:text-white">API</a></li>
                <li><a href="#" className="hover:text-white">Metodología</a></li>
                <li><a href="#" className="hover:text-white">Fuentes</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Legal</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="hover:text-white">Términos</a></li>
                <li><a href="#" className="hover:text-white">Privacidad</a></li>
              </ul>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-gray-800 text-sm text-gray-400">
            © 2026 SEPOM. Datos de fuentes oficiales.
          </div>
        </div>
      </footer>
    </div>
  );
}
